import styled, { css } from 'styled-components';
import { Input } from '@/components/UI/Input/Input';

export const Form = styled.div<{ $noGutters: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 35px;
  padding: ${({ $noGutters }) => ($noGutters ? '0' : '10px 0 20px')};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 25px;
  }
`;

export const InputWrapper = styled.div<{ $hasError: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 14px;
  padding: 0 15px;
  height: 52px;
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
  transition: border-color 0.2s ease-in-out;

  &:focus-within {
    border-color: ${({ theme }) => theme.palette.brand.main};
  }

  ${({ $hasError }) =>
    $hasError &&
    css`
      border-color: ${({ theme }) => theme.palette.system.red};
      background-color: ${({ theme }) => theme.palette.system.redLight};

      label {
        color: ${({ theme }) => theme.palette.system.red};
      }
    `}
`;

export const ErrorText = styled.p`
  font-size: 14px;
  padding: 0;
  margin: -15px 0 0;
  color: ${({ theme }) => theme.palette.system.red};
`;

export const NameInput = styled(Input).attrs({
  type: 'search',
  autoCorrect: 'off',
  autoComplete: 'off',
  spellCheck: 'false',
  autoCapitalize: 'none',
})``;
